"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadProductProperties = exports.loadContactProperties = exports.loadCompanyProperties = exports.FetchProductProperties = exports.FetchContactProperties = exports.FetchCompanyProperties = exports.FetchProductPropertiesActionTypes = exports.FetchContactPropertiesActionTypes = exports.FetchCompanyPropertiesActionTypes = exports.PropertyActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var _constants = require("./constants");

var PropertyActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_COMPANY_PROPERTIES: null,
  FETCH_COMPANY_PROPERTIES: null,
  LOAD_CONTACT_PROPERTIES: null,
  FETCH_CONTACT_PROPERTIES: null,
  LOAD_PRODUCT_PROPERTIES: null,
  FETCH_PRODUCT_PROPERTIES: null
}, _constants.PROPERTY);
exports.PropertyActionTypes = PropertyActionTypes;
var FetchCompanyPropertiesActionTypes = (0, _actions.createRequestTypes)(PropertyActionTypes.FETCH_COMPANY_PROPERTIES);
exports.FetchCompanyPropertiesActionTypes = FetchCompanyPropertiesActionTypes;
var FetchContactPropertiesActionTypes = (0, _actions.createRequestTypes)(PropertyActionTypes.FETCH_CONTACT_PROPERTIES);
exports.FetchContactPropertiesActionTypes = FetchContactPropertiesActionTypes;
var FetchProductPropertiesActionTypes = (0, _actions.createRequestTypes)(PropertyActionTypes.FETCH_PRODUCT_PROPERTIES);
exports.FetchProductPropertiesActionTypes = FetchProductPropertiesActionTypes;
var FetchCompanyProperties = (0, _actions.createRequestActions)(FetchCompanyPropertiesActionTypes);
exports.FetchCompanyProperties = FetchCompanyProperties;
var FetchContactProperties = (0, _actions.createRequestActions)(FetchContactPropertiesActionTypes);
exports.FetchContactProperties = FetchContactProperties;
var FetchProductProperties = (0, _actions.createRequestActions)(FetchProductPropertiesActionTypes);
exports.FetchProductProperties = FetchProductProperties;
var loadCompanyProperties = (0, _fluxActions.createAction)(PropertyActionTypes.LOAD_COMPANY_PROPERTIES);
exports.loadCompanyProperties = loadCompanyProperties;
var loadContactProperties = (0, _fluxActions.createAction)(PropertyActionTypes.LOAD_CONTACT_PROPERTIES);
exports.loadContactProperties = loadContactProperties;
var loadProductProperties = (0, _fluxActions.createAction)(PropertyActionTypes.LOAD_PRODUCT_PROPERTIES);
exports.loadProductProperties = loadProductProperties;